import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
//import $ from 'jquery';
import Vas from '../../../Vas';
import '../../../css/CustomerCard.css';
import CustomerLegalGuardianDetails from './CustomerLegalGuardianDetails';

import { RoleConfiguration } from 'utils-lib';
import { PagingTable } from 'component-lib';
import { AdditionalAddressesModel, RequestAjaxClass } from 'models-lib';
var moment = require('moment');
moment().format();

class CustomerLegalGuardianData extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {};
        this.CustomerId = props.id;
        this.AdditionalAddressesModel = new AdditionalAddressesModel([this]);
        this.GetRequest =  new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
    }

    componentWillMount(){
        $("#LoadingIcon").removeClass().addClass('loaderSmall');
        this.GetRequest.setApiUrl(Vas.ApiUrl);
        this.GetRequest.setApiKey(Vas.ApiKey);
        this.GetRequest.setAuth(true);
        this.AdditionalAddressesModel.SetRequest(this.GetRequest);
    }

    Update(observer)
    {
        let me = this;
        this.setState({},()=>{
            if(observer === "AdditionalAddresses"){
                $("#LoadingIcon").removeClass().addClass('hide');
                let legalGuardians = [];
                let addresses = this.AdditionalAddressesModel.AdditionalAddresses;
                for (let i = 0; i< addresses.length; i++){
                    let value = addresses[i];
                    if (value.AddressType.Name === "Erz1"){
                        legalGuardians.push(value);
                    }
                }
                    
                if (me.refs.table){
                    me.refs.table.setState({ Data: legalGuardians, Count: legalGuardians.length, Limit: me.refs.table.state.Limit, Start: me.refs.table.state.Start, End: me.refs.table.state.Start+legalGuardians.length });
                }
            }
        });
    }

    load(sendData){
        this.AdditionalAddressesModel.GetAdditionalAddressesByCustomerId(this.CustomerId);
    }

    LoadContractDetails(id,data)
    {
        ReactDOM.unmountComponentAtNode(document.getElementById('legalGuardianDetails'));
        ReactDOM.render(<CustomerLegalGuardianDetails
          Id={id}
          data={data}
          reference={this}
          table={this.refs.table}
          CustomerId={this.CustomerId} />, document.getElementById('legalGuardianDetails'));
    }

    createLegalGuardian(){
        Vas.GetView('CreateLegalGuardian',{ CustomerId:this.CustomerId },true);
        
    }

    loadLegalGuardian(id){
        let me = this;
        let legalGuardians=me.refs.table.state.Data;
        let legalGuardian=[];
        for (let i=0;i<legalGuardians.length;i++){
            if (legalGuardians[i].Id === id){
                legalGuardian.push(legalGuardians[i]);
            }
        }
        me.LoadContractDetails(id,legalGuardian);
    }

    render()
    {   
        let rights = RoleConfiguration.getRoleConfig();
        let role = localStorage.getItem("vas_role");
        
        //let right = '';
        if (role === "1"){
            if (rights[1]){
               //right =  rights[1]; 
            }
        }
        if (role === "3" || role === "99"){
            if (rights[0]){
                //right = rights[0];
            }
        }

        let searchParamsStrings = [];
        searchParamsStrings.push({ TableColumn: "customerId", SearchValue: this.CustomerId });

        //return (<div></div>);
       return (<div ><table >
         <thead>
         </thead>
         <tbody>
           <tr>
             <td>
               <PagingTable 
               ErrorHandlingPage={(error)=>{Vas.ErrorHandling(error);}}
                 ref="table" 
                 SearchParamsStrings={searchParamsStrings} 
                 TableReference={this} 
                 DataBaseTable={"B2Vertraege"} 
                 Selectable={false} 
                 Limit={this.state.Limit} 
                 Start={this.state.Start} 
                 End={this.state.End} 
                 Count={this.state.Count} 
                 Columns={[Vas.Resources.Labels["Name"],Vas.Resources.Labels["FirstName"],Vas.Resources.Labels["Zip"],Vas.Resources.Labels["City"]]}
                 Keys={["Name1","Name2","Zip","City"]} 
                 Data={this.state.Data} 
                 Border={false}
                 RowOnClick={(id)=>{this.loadLegalGuardian(id);}}
                 LabelPage={Vas.Resources.Labels["Page"]}
                 LabelOf={Vas.Resources.Labels["Of"]}
                 LabelCountPerPage={Vas.Resources.Labels["CountPerPage"]}
                 Add={true}
                 AddClick={()=>{this.createLegalGuardian();}}
                 AddString={Vas.Resources.Labels["Add"]}
                        />
             </td>
           </tr>
            
         </tbody>
        
       </table><div
         className={"contractDetails"}
         id={"legalGuardianDetails"}>{Vas.Resources.Labels["NoLegalGuardian"]}</div></div>);
    }
}
export default CustomerLegalGuardianData;
